<template>
  <div>
    <b-button size="sm" @click="OpenModal()">Nova Revisão</b-button>
    <b-modal title="Nova Revisão" v-model="showModal" hide-footer>
      <revision-create
        :model.sync="newRevision"
        @save="addRevision"
        @hide="showModal = false"
      />
    </b-modal>
    <b-table striped hover :items="model.revisions" :fields="fields">
      <template #cell(actions)="data">
        <b-button size="sm" @click="editItem(data.item)">Editar</b-button>
        <b-button
          style="margin-left: 5px;"
          size="sm"
          variant="danger"
          @click="removeItem(data.item)"
          >Excluir</b-button
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import RevisionCreate from "@/components_rms/vehicle/Revision/RevisionCreate.vue";

export default {
  name: "RevisionModal",
  props: {
    model: Object
  },
  components: {
    RevisionCreate
  },
  data() {
    return {
      showModal: false,
      newRevision: {
        description: "",
        measurementType: null,
        active: true,
        kilometers: null,
        horimeter: null,
        days: null
      },
      fields: [
        { key: "actions", label: "" },
        { key: "description", label: "Descrição" },
        { key: "kilometers", label: "Quilômetros" },
        { key: "horimeter", label: "Horimetro" },
        { key: "days", label: "Dias" }
      ]
    };
  },
  methods: {
    editItem(item) {
      this.newRevision = { ...item };
      this.showModal = true;
    },
    removeItem(item) {
      const index = this.model.revisions.indexOf(item);
      if (index !== -1) {
        this.model.revisions.splice(index, 1);
      }
    },
    OpenModal() {
      this.newRevision = {
        description: "",
        measurementType: null,
        active: true,
        kilometers: null,
        horimeter: null,
        days: null
      };
      this.showModal = true;
    },
    addRevision() {
      this.model.revisions = this.model.revisions || [];
      this.model.revisions.push(this.newRevision);
      this.showModal = false;
      this.newRevision = {
        description: "",
        measurementType: null,
        active: true,
        kilometers: null,
        horimeter: null,
        days: null
      };
    },
    activateItem(item) {
      item.active = true;
    },
    deactivateItem(item) {
      item.active = false;
    }
  }
};
</script>
